<script setup lang="ts"></script>

<template>
  <BaseTextButton>
    <div class="flex flex-row items-center justify-start w-full">
      <slot name="icon" />
      <span class="ml-1">
        <slot />
      </span>
    </div>
  </BaseTextButton>
</template>

<style scoped></style>
